export const OVERVIEW_TAB = {
    BY_PROJECT: 'by_project',
    STANDALONE: 'standalone',
} as const;

export const OVERVIEW_STATUS_FILTER = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
} as const;
